<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>
                    <v-icon>fa-car</v-icon> Autos:
                    <v-spacer/>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                    />
                    <v-btn @click="openModal()" class="mx-2 py-0" color="primary"><v-icon>add_circle</v-icon></v-btn>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="autos"
                        :items-per-page="5"
                        :search="search"
                        class="elevation-1"
                        ref="table"
                >
                    <template v-slot:item.autorizado="{ item }">
                        <v-badge :color="item.autorizado ? 'success' : 'danger' ">{{ item.autorizado ? 'Si' : 'No' }}</v-badge>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-icon
                        small
                        class="mr-2"
                        @click="generateQR(item)">fa-qrcode</v-icon>
                        <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                                small
                                @click="deleteItem(item)"
                        >
                            delete
                        </v-icon>
                    </template>
                </v-data-table>
                <v-dialog
                        v-model="dialog"
                        width="600"

                >
                    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
                        <v-card>
                            <v-card-title class="headline text-center">{{edit ? 'Editar': 'Crear'}} Auto</v-card-title>
                            <v-form
                                    @submit.prevent="handleSubmit(formSubmit)"
                                    ref="form"
                                    lazy-validation
                                    class="container"
                            >
                                <v-row no-gutters>
                                    <v-col cols="12" md="6">
                                        <ValidationProvider rules="required" name="name" v-slot="{ errors, valid }">
                                            <v-text-field
                                                    v-model="auto.name"
                                                    name="name"
                                                    label="Nombre:"
                                                    placeholder="Ingresa el nombre"
                                                    :error-messages="errors"
                                                    :success="valid"
                                            />
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <ValidationProvider rules="required" name="fabricante" v-slot="{ errors, valid }">
                                            <v-text-field
                                                    v-model="auto.fabricante"
                                                    name="fabricante"
                                                    label="Nombre:"
                                                    placeholder="Ingresa el fabricante"
                                                    :error-messages="errors"
                                                    :success="valid"
                                            />
                                        </ValidationProvider>

                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="12" md="6">
                                        <ValidationProvider rules="required" name="modelo" v-slot="{ errors, valid }">
                                            <v-text-field
                                                    v-model="auto.modelo"
                                                    name="modelo"
                                                    label="Modelo:"
                                                    placeholder="Ingrese el modelo"
                                                    :error-messages="errors"
                                                    :success="valid"
                                            />
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <ValidationProvider rules="required" name="color" v-slot="{ errors, valid }">
                                            <v-text-field
                                                    v-model="auto.color"
                                                    name="color"
                                                    label="Color:"
                                                    placeholder="Ingrese el color"
                                                    :error-messages="errors"
                                                    :success="valid"
                                            />
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="12" md="6" >
                                        <ValidationProvider rules="required" name="autorizado" v-slot="{ errors, valid }">
                                            <v-switch
                                                name="autorizado"
                                                label="¿Autorizado?"
                                                v-model="auto.autorizado"
                                                :error-messages="errors"

                                            />
                                        </ValidationProvider>
                                    </v-col>

                                    <v-col cols="12" md="6" >
                                        <ValidationProvider rules="required" name="matricula" v-slot="{ errors, valid }">
                                            <v-text-field
                                                    v-model="auto.matricula"
                                                    name="matricula"
                                                    label="Matricula:"
                                                    placeholder="Ingrese la matricula"
                                                    :error-messages="errors"
                                                    :success="valid"
                                            />
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="12" md="6" >
                                        <ValidationProvider rules="required" name="condominio" v-slot="{ errors, valid }">
                                            <v-select
                                                    name="condominio"
                                                    v-model="auto.condominio"
                                                    label="Condominio"
                                                    placeholder="Ingresa el condominio"
                                                    :error-messages="errors"
                                                    :success="valid"
                                                    :items="condominios"
                                                    item-text="name"
                                            />

                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="6" >
                                        <ValidationProvider rules="required" name="apartamento" v-slot="{ errors, valid }">
                                            <v-text-field
                                                    v-model="auto.apartamento"
                                                    name="apartamento"
                                                    label="Apartamento:"
                                                    placeholder="Ingrese el apartamento"
                                                    :error-messages="errors"
                                                    :success="valid"
                                            />
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                                <v-card-actions>


                                    <v-spacer/>
                                    <v-btn color="primary" type="submit">{{edit ? 'Editar' : 'Guardar'}}</v-btn>


                                </v-card-actions>
                            </v-form>

                        </v-card>
                    </ValidationObserver>
                </v-dialog>
                <v-snackbar
                        color="success"
                        v-model="snackbar"
                >
                    {{ text }}
                    <v-btn
                            color="darken"
                            text
                            @click="snackbar = false"
                    >
                        Cerrar
                    </v-btn>
                </v-snackbar>
            </v-card>
            <v-dialog width="500" v-model="dialogqr">
                <v-card class="text-center">
                    <v-card-title class="justify-center"><h1>Codigo QR</h1></v-card-title>
                    <vue-qr :callback="test"  logoSrc="https://i.ibb.co/8bcpw5q/logo-miserino.png" bgSrc="https://i.ibb.co/8bcpw5q/logo-miserino.png" :text="qr_id" :size="300"></vue-qr>
                    <br>
                    <a class="blue--text v-btn v-btn--text my-2 mb-2" style="text-decoration: none" :href="imgDescarga" :download="qr_name">Descargar</a>
                </v-card>
            </v-dialog>
        </v-container>
    </v-content>

</template>

<script>
    import VueQr from 'vue-qr'

    import {mapState, mapActions} from "vuex";
    import {
        ValidationObserver,
    } from "vee-validate";

    export default {
        name: "Autos",
        data(){
            return{
                dialogqr:false,
                qr_id:'',
                qr_name:'',
                imgDescarga:'',
                idAuto:null,
                search:'',
                dialog:false,
                edit:false,
                snackbar:false,
                text:'',
                headers: [
                    {
                        text: 'Conductor',
                        align: 'left',
                        sortable: true,
                        value: 'name',
                    },
                    { text: 'Condominio', value: 'condominio' },
                    { text: 'Apartamento', value: 'apartamento' },
                    { text: 'Color', value: 'color' },
                    { text: 'Fabricante', value: 'fabricante' },
                    { text: 'Modelo', value: 'modelo' },
                    { text: 'Matricula', value: 'matricula' },
                    { text: 'Autorizado', value: 'autorizado' },
                    //{ text: 'Creado', value: 'createdAt' },
                    { text: 'Opciones', value: 'actions' },

                ],
                auto:{
                    name: '',
                    condominio: '',
                    apartamento:'',
                    color:'',
                    fabricante:'',
                    modelo:'',
                    autorizado:false,
                    matricula:'',
                    createdAt: ''
                }

            }
        },
        methods:{
            ...mapActions([
                'deleteCollect', 'editCollect', 'createAuto'
            ]),
            test(dataUrl){
                //console.log(dataUrl)
                this.imgDescarga = dataUrl
            },
            openModal(){
                this.idAuto = null;
                this.edit = false
                this.auto = {
                    name: '',
                    condominio: '',
                    apartamento:'',
                    color:'',
                    fabricante:'',
                    modelo:'',
                    autorizado:false,
                    matricula:'',
                    createdAt: ''
                };
                this.dialog = true;

            },

            deleteItem(item){
                this.deleteCollect({id:item.id , collection:'autos'})
            },
            editItem(item){
                this.edit =true;
                this.auto.name = item.name;
                this.auto.condominio = item.condominio;
                this.auto.apartamento = item.apartamento;
                this.auto.color = item.color;
                this.auto.fabricante = item.fabricante;
                this.auto.modelo = item.modelo;
                this.auto.autorizado = item.autorizado;
                this.auto.matricula = item.matricula;

                this.idAuto = item.id;
                this.dialog = true
            },
            editAuto(){
                this.editCollect({id:this.idAuto, data:this.auto, collection:'autos' });
                this.dialog = false;
                this.text = 'Se ha actualizado satisfactoriamente';
                this.snackbar = true;
            },
            generateQR(value){
                this.qr_id = value.id;
                this.qr_name = value.name;
                this.dialogqr = true
            },
            saveAuto(){
                this.createAuto(this.auto);
                this.dialog = false;
                this.text = 'Se ha creado satisfactoriamente';
                this.snackbar = true;
            },
            formSubmit(){
                if (this.edit){
                    this.editAuto()
                }else{
                    this.saveAuto()
                }
            }

        },
        components:{
            ValidationObserver, VueQr
        },
        computed:{
            condominios(){
                return this.$store.getters.condominios
            },
            ...mapState({
                autos:state =>state.auto.autos
            })
        }
    }
</script>

<style scoped>

</style>